module.exports = __webpack_public_path__ + "media/images/icon_map-bc8b8fa880d3f9ab90e206ab053dd845.svg";